import { createFileRoute } from "@tanstack/react-router"
import { ProfileEiLeaderboardPage } from "@/pages/profile/ei-leaderboard"

export const Route = createFileRoute("/_authenticated/profile/ei-leaderboard")({
	component: ProfileEiLeaderboardPageWrapper,
	validateSearch: (search: Record<string, unknown>): { userId?: number } => {
		const userId = Number(search.userId)
		return Number.isInteger(userId) && userId > 0 ? { userId } : {}
	},
})

function ProfileEiLeaderboardPageWrapper() {
	const { userId } = Route.useSearch()
	return <ProfileEiLeaderboardPage userId={userId} />
}
